// roles
import D2C_ServiceApp from './App'
import D2C_ServiceData from './Data'
import D2C_ServiceOther from './Other'
import D2C_ServiceWeb from './Web'
// app services
import D2C_ServiceGo from './Go'
import D2C_ServiceNginxStatic from './NginxStatic'
import D2C_ServiceNodejs from './Nodejs'
import D2C_ServicePHP from './PHP'
import D2C_ServicePHPApache from './PHPApache'
import D2C_ServicePHPNginx from './PHPNginx'
import D2C_ServicePython from './Python'
import D2C_ServiceRuby from './Ruby'
// data services
import D2C_ServiceCrate from './Crate'
import D2C_ServiceElasticsearch from './Elasticsearch'
import D2C_ServiceEtcd from './Etcd'
import D2C_ServiceMariaDB from './MariaDB'
import D2C_ServiceMemcached from './Memcached'
import D2C_ServiceMongoDB from './MongoDB'
import D2C_ServiceMySQL from './MySQL'
import D2C_ServicePercona from './Percona'
import D2C_ServicePostgres from './Postgres'
import D2C_ServiceRedis from './Redis'
// web services
import D2C_ServiceHAProxy from './HAProxy'
import D2C_ServiceNginx from './Nginx'
import D2C_ServiceNginxCluster from './NginxCluster'
import D2C_ServiceVarnish from './Varnish'
// other services
import D2C_ServiceDocker from './Docker'
import D2C_ServiceSkyDNS from './SkyDNS'

export default {
  // roles
  ServiceApp: D2C_ServiceApp,
  ServiceData: D2C_ServiceData,
  ServiceOther: D2C_ServiceOther,
  ServiceWeb: D2C_ServiceWeb,
  // app services
  ServiceGo: D2C_ServiceGo,
  ServiceNginxStatic: D2C_ServiceNginxStatic,
  ServiceNodejs: D2C_ServiceNodejs,
  ServicePHP: D2C_ServicePHP,
  ServicePHPApache: D2C_ServicePHPApache,
  ServicePHPNginx: D2C_ServicePHPNginx,
  ServicePython: D2C_ServicePython,
  ServiceRuby: D2C_ServiceRuby,
  // data services
  ServiceCrate: D2C_ServiceCrate,
  ServiceElasticsearch: D2C_ServiceElasticsearch,
  ServiceEtcd: D2C_ServiceEtcd,
  ServiceMariaDB: D2C_ServiceMariaDB,
  ServiceMemcached: D2C_ServiceMemcached,
  ServiceMongoDB: D2C_ServiceMongoDB,
  ServiceMySQL: D2C_ServiceMySQL,
  ServicePercona: D2C_ServicePercona,
  ServicePostgres: D2C_ServicePostgres,
  ServiceRedis: D2C_ServiceRedis,
  // web services
  ServiceHAProxy: D2C_ServiceHAProxy,
  ServiceNginx: D2C_ServiceNginx,
  ServiceNginxCluster: D2C_ServiceNginxCluster,
  ServiceVarnish: D2C_ServiceVarnish,
  // other services
  ServiceDocker: D2C_ServiceDocker,
  ServiceSkyDNS: D2C_ServiceSkyDNS,
}
